import { createSlice } from '@reduxjs/toolkit';

/**
 * owner: which feature put this message on screen. Everything shares one snackbar, so a feature
 *   that closes it on a timer cannot otherwise tell "my notice is still up" from "someone else's
 *   warning replaced it" — and closes the warning. closeSnackbar() without an owner still closes
 *   whatever is showing (the user pressing ×, MUI's own auto-hide).
 *
 * seq: bumped on every message so CustomSnackbar can key the MUI Snackbar on it. MUI restarts its
 *   auto-hide timer only when `open` or `autoHideDuration` changes, so a message replacing one
 *   that is already showing ran out the previous message's remaining time instead of its own.
 */
const initialState = { open: false, message: '', severity: 'success', owner: null, seq: 0 };

const snackBarSlice = createSlice({
    name: 'snackBar',
    initialState: initialState,
    reducers: {
        initSnackbar: (state, action) => {
            return initialState;
        },
        setSnackbar: (state, action) => {
            return { ...action.payload, seq: state.seq + 1 };
        },
        closeSnackbar: (state, action) => {
            const owner = action.payload?.owner;
            // Named an owner, but someone else's message is showing → leave it alone.
            if (owner && owner !== state.owner) return;
            state.open = false;
        },
    },
});

export const { initSnackbar, setSnackbar, closeSnackbar } = snackBarSlice.actions;
export default snackBarSlice.reducer;
